import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getInvoicesKey } from '../../utils/keys';
export const usePurchase = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(input => client.billing.purchase(input), {
        onSettled: () => {
            const invoicesKey = getInvoicesKey();
            queryClient.invalidateQueries(invoicesKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=usePurchase.js.map